<template>
  <v-navigation-drawer v-model="menuLateral" temporary fixed clipped app>
    <v-layout class="mt-3" row wrap justify-center align-center>
      <v-flex xs4>
        <v-card dark width="100">
          <v-img height="100" :src="`${usuarioLogado.avatar ? usuarioLogado.avatar : defaultAvatar
          }`"></v-img>
        </v-card>
      </v-flex>
      <v-flex xs12 class="text-xs-center">
        <span class="headline">{{ usuarioLogado.nome }}</span>
        <br />
        <span v-if="usuarioLogado.idtipousuario != perfilUsr.ID.clienteMetta">Franquia: {{
          usuarioLogado.nomeconta
        }}</span>
      </v-flex>
    </v-layout>

    <v-list>
      <v-list-group no-action sub-group value="true" v-if="usuarioLogado.idtipousuario != perfilUsr.ID.clienteMetta">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Clientes</v-list-tile-title>
          </v-list-tile>
        </template>

        <v-list-tile @click="go('Empresas')">
          <v-list-tile-action>
            <v-icon color="primary">business_center</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Empresas</v-list-tile-title>
        </v-list-tile>

        <v-list-tile @click="go('Pessoas')">
          <v-list-tile-action>
            <v-icon color="primary">group</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Pessoas</v-list-tile-title>
        </v-list-tile>
      </v-list-group>

      <v-list-tile @click="go('Agendas')" v-if="usuarioLogado.idtipousuario != perfilUsr.ID.clienteMetta">
        <v-list-tile-action>
          <v-icon color="primary">book</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Agenda</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-group no-action sub-group value="true" v-if="usuarioLogado.idtipousuario != perfilUsr.ID.clienteMetta">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Negócios</v-list-tile-title>
          </v-list-tile>
        </template>

        <v-list-tile @click="go('NegociosEmpresa')">
          <v-list-tile-action>
            <v-icon color="primary">fa fa-briefcase</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Negócios Empresas</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click="go('NegociosPessoaPrimeiroContato')">
          <v-list-tile-action>
            <v-icon color="primary">fa fa-briefcase</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Neg. Pessoas - 1º Contato</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click="go('NegociosPessoaPosVenda')">
          <v-list-tile-action>
            <v-icon color="primary">fa fa-briefcase</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Neg. Pessoas - Pós Venda</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click="go('PessoasAniversariantes')">
          <v-list-tile-action>
            <v-icon color="primary">fa fa-briefcase</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Aniversariantes</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <!-- <v-list-tile @click="go('NegociosPessoa')">
          <v-list-tile-action>
            <v-icon color="primary">fa fa-briefcase</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Negócios Pessoas</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile> -->
      </v-list-group>

      <v-list-tile @click="go('HistoricoCaxia')" v-if="
        usuarioLogado.idtipousuario == perfilUsr.ID.franquiado ||
        usuarioLogado.idtipousuario == perfilUsr.ID.administrador ||
        usuarioLogado.idtipousuario == perfilUsr.ID.operadorMaster
      ">
        <v-list-tile-action>
          <v-icon color="blue">attach_money</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Caixa</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile @click="go('VendasSite')" v-if="usuarioLogado.idtipousuario >= perfilUsr.ID.operador">
        <v-list-tile-action>
          <v-icon color="green">shopping_cart</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Vendas no Site</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile @click="go('Despesas')" v-if="
        usuarioLogado.idtipousuario == perfilUsr.ID.franquiado ||
        usuarioLogado.idtipousuario == perfilUsr.ID.administrador ||
        usuarioLogado.idtipousuario == perfilUsr.ID.secretariaMaster
      ">
        <v-list-tile-action>
          <v-icon color="red">attach_money</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Despesas</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile @click="go('Download')" v-if="usuarioLogado.idtipousuario == perfilUsr.ID.clienteMetta">
        <v-list-tile-action>
          <v-icon color="blue">system_update_alt</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Download</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      
      <v-list-tile @click="editarUsuario(cipherComputed.encrypt(usuarioLogado.id))"
        v-if="usuarioLogado.idtipousuario == perfilUsr.ID.clienteMetta">
        <v-list-tile-action>
          <v-icon color="blue">group</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Meu Perfil</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-group no-action sub-group value="true" v-if="usuarioLogado.idtipousuario != perfilUsr.ID.clienteMetta">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Relatório</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list-tile @click="go('CaixaDiario')" v-if="
          usuarioLogado.idtipousuario == perfilUsr.ID.franquiado ||
          usuarioLogado.idtipousuario == perfilUsr.ID.administrador
        ">
          <v-list-tile-action>
            <v-icon color="blue">assessment</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Caixa Diário</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="go('CaixaDiarioCompleto')" v-if="
          usuarioLogado.idtipousuario == perfilUsr.ID.franquiado ||
          usuarioLogado.idtipousuario == perfilUsr.ID.administrador
        ">
          <v-list-tile-action>
            <v-icon color="blue">assessment</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Caixa Diário - Completo</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="go('CaixaMensal')" v-if="
          usuarioLogado.idtipousuario == perfilUsr.ID.franquiado ||
          usuarioLogado.idtipousuario == perfilUsr.ID.administrador
        ">
          <v-list-tile-action>
            <v-icon color="blue">assessment</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Caixa Mensal</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="go('CustoDiario')" v-if="
          usuarioLogado.idtipousuario == perfilUsr.ID.franquiado ||
          usuarioLogado.idtipousuario == perfilUsr.ID.administrador ||
          usuarioLogado.idtipousuario == perfilUsr.ID.secretariaMaster
        ">
          <v-list-tile-action>
            <v-icon color="red">assessment</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Custo Diário</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="go('CustoMensal')" v-if="
          usuarioLogado.idtipousuario == perfilUsr.ID.franquiado ||
          usuarioLogado.idtipousuario == perfilUsr.ID.administrador
        ">
          <v-list-tile-action>
            <v-icon color="red">assessment</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Custo Mensal</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="go('CustoVSReceita')" v-if="
          usuarioLogado.idtipousuario == perfilUsr.ID.franquiado ||
          usuarioLogado.idtipousuario == perfilUsr.ID.administrador
        ">
          <v-list-tile-action>
            <v-icon color="primary">assessment</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Custo Vs. Receita</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="go('ProdutosMaisVendidos')" v-if="
          usuarioLogado.idtipousuario == perfilUsr.ID.franquiado ||
          usuarioLogado.idtipousuario == perfilUsr.ID.administrador
        ">
          <v-list-tile-action>
            <v-icon color="primary">assessment</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Produtos + Vendidos</v-list-tile-title>
        </v-list-tile>
      </v-list-group>

      <v-list-group no-action sub-group value="true" v-if="usuarioLogado.idtipousuario != perfilUsr.ID.clienteMetta">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Configurações</v-list-tile-title>
          </v-list-tile>
        </template>

        <v-list-tile @click="go('Produtos')" v-if="usuarioLogado.idtipousuario == perfilUsr.ID.franquiado ||
        usuarioLogado.idtipousuario == perfilUsr.ID.administrador">
          <v-list-tile-action>
            <v-icon color="primary">settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Produtos</v-list-tile-title>
        </v-list-tile>

        <v-list-tile @click="go('Origens')" v-if="usuarioLogado.idtipousuario == perfilUsr.ID.administrador">
          <v-list-tile-action>
            <v-icon color="primary">settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Origem</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="go('Segmentos')" v-if="usuarioLogado.idtipousuario == perfilUsr.ID.administrador">
          <v-list-tile-action>
            <v-icon color="primary">settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Segmento Empresa</v-list-tile-title>
        </v-list-tile>

        <v-list-tile @click="go('TipoDespesas')" v-if="usuarioLogado.idtipousuario == perfilUsr.ID.administrador">
          <v-list-tile-action>
            <v-icon color="primary">settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Despesas</v-list-tile-title>
        </v-list-tile>

        <v-list-tile @click="go('Usuarios')" v-if="
          usuarioLogado.idtipousuario == perfilUsr.ID.franquiado ||
          usuarioLogado.idtipousuario == perfilUsr.ID.administrador
        ">
          <v-list-tile-action>
            <v-icon color="primary">group</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Usuários</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="go('Contas')" v-if="usuarioLogado.idtipousuario == perfilUsr.ID.administrador">
          <v-list-tile-action>
            <v-icon color="primary">business_center</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Franquia</v-list-tile-title>
        </v-list-tile>
      </v-list-group>

      <v-list-tile @click="fazerLogout">
        <v-list-tile-action>
          <v-icon color="primary">exit_to_app</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Sair</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import jwt from "@/helpers/jwt";
import permissoes from "@/helpers/permissoes.js";
import usuarioHelper from "@/helpers/usuario.js";
import cipher from "@/helpers/cipher.js";
import perfil from "@/helpers/perfil.js";

export default {
  name: "SideMenu",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      menuLateral: false,
      defaultAvatar: "/static/images/default-user.png",
      getCurrentUser() {
        var token = jwt.decryptToken();
        if (!token) {
          localStorage.removeItem("token");
          this.$router.push("/login");
        }
        return token;
      },
    };
  },
  computed: {
    perfilUsr: function () {
      return perfil;
    },
    usuarioLogado: function () {
      return usuarioHelper.USUARIO_LOGADO();
    },
    cipherComputed: function () {
      return cipher;
    },
  },
  watch: {
    value: function (newValue) {
      this.menuLateral = newValue;
    },
    menuLateral: function (newValue) {
      this.$emit("input", newValue);
    },
  },
  methods: {
    getPermissao: function (requested, param) {
      const permissionObj = permissoes;
      if (param) {
        return eval(
          "permissionObj." +
          this.$route.name +
          "." +
          requested +
          "(" +
          param +
          ")"
        );
      } else {
        return eval("permissionObj." + this.$route.name + "." + requested);
      }
    },
    fazerLogout: function () {
      const self = this;
      localStorage.removeItem("token");
      self.$router.push("/login");
      location.reload();
    },
    editarUsuario: function (id) {
      const self = this;

      self.go("CadastroUsuario", 1);
    },
    go: function (routeName, routeParams) {
      const self = this;
      if (this.$router.currentRoute.name != routeName) {
        if (!routeParams) {
          self.$router.push({ name: routeName });
        } else {
          self.$router.push({ name: routeName, params: routeParams });
        }
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/compartilhados/SideMenu.vue